module.exports = __webpack_public_path__ + "static/media/1004938.7d994c53.png";